import { graphql } from "../generated";

export const MUTATE_DELETE_ANIMATION_FOLDER = graphql(`
  mutation MutateDeleteAnimationFolder($id: String!) {
    deleteAnimationFolder(id: $id)
  }
`);
